import {
	startShake,
	stopShake,
	useLayoutDispatch,
	useLayoutSelector,
} from '../redux';

export const useShake = () => {
	const dispatch = useLayoutDispatch();
	const isShaking = useLayoutSelector((state) => state.shake.isShaking);

	const shake = () => {
		dispatch(startShake());
		setTimeout(() => {
			dispatch(stopShake());
		}, 500);
	};

	return { shake, isShaking };
};
